import React from "react";
import { Field } from "redux-form";

import { customTextarea } from "../../../../../common/customTextarea";
import styles from "../../../SwmsMastersStyle.module.css";
import v2Styles from "../../../../v2Styles.module.css";
import PerformRescueSection from "../../../EmergencyProcedures/sections/section-types/PerformRescueSection";

export default function EmergencyResponseProcedureSection({ loading }) {
  return (
    <div className="pb-2">
      <div className="container-fluid">
        <div className="row pt-2">
          <div className="col-12">
            <div className={styles.Label}>Summary</div>
            <Field
              name="summary"
              component={customTextarea}
              className={`${v2Styles.TextArea} ${v2Styles.AutoHeight} ${v2Styles.Rows2}`}
              disabled={loading}
              placeholder="Summary"
              rows={2}
              autoComplete="off"
            />
          </div>
        </div>
      </div>
      <PerformRescueSection loading={loading} />
    </div>
  );
}